import { BagIcon } from '~/components/icons/generated/BagIcon'
import { CoordinateIcon } from '~/components/icons/generated/CoordinateIcon'
import { FavoriteIcon } from '~/components/icons/generated/FavoriteIcon'
import { TabItem } from '~/features/shared/components/TabItem'

type Tabs = 'posts' | 'folders' | 'products'
type Props = {
  userName: string
  activeTab: Tabs
}

export const MemberContentTab: React.FC<Props> = ({ userName, activeTab }) => {
  return (
    <div
      className="flex justify-center bg-white px-4 text-[14px] shadow-tab xl:border-b xl:border-gray-300 xl:px-0 xl:shadow-none"
      role="tablist"
      aria-label="プロフィールメニュー"
    >
      <div className="flex w-full xl:max-w-[990px]">
        <TabItem
          href={`/${userName}/`}
          selected={activeTab === 'posts'}
          icon={<CoordinateIcon className="h-6" />}
          title="投稿"
        />
        <TabItem
          href={`/${userName}/favorite/`}
          selected={activeTab === 'folders'}
          icon={<FavoriteIcon className="h-6" />}
          title="お気に入り"
        />
        <TabItem
          href={`/${userName}/products/`}
          selected={activeTab === 'products'}
          icon={<BagIcon className="h-6" />}
          title="フリマ"
        />
      </div>
    </div>
  )
}
